import CantileverCard from 'components/CantileverCard'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { useImagesContext } from './ImagesContext'
import { ImagesSubSection } from './ImagesSubSection'

const NoImagesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.875rem;
  align-self: stretch;
  color: ${({ theme }) => theme.forecast.tertiaryText};
`

const SectionNameText = styled.p`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${({ theme }) => theme.forecast.text1};
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`

export const ImagesSubSectionContainer: React.FC<{
  subSectionType: 'Component' | 'Inspection'
}> = ({ subSectionType }) => {
  const { components, inspections, assetThumbnailURLs, assetThumbnails } =
    useImagesContext()

  const isComponent = subSectionType === 'Component'
  const subSectionItems = isComponent ? components : inspections

  const getThumbnailUrls = useCallback(
    (itemId: string, itemType: 'Component' | 'Inspection') => {
      const isComponentType = itemType === 'Component'

      const indexes = assetThumbnails.reduce<number[]>(
        (acc, thumbnail, index) => {
          const matchesItemType = isComponentType
            ? thumbnail.data.components &&
              (thumbnail.data.components as string[]).includes(itemId) &&
              (!thumbnail.data.inspections ||
                thumbnail.data.inspections?.length === 0)
            : thumbnail.data.inspections &&
              (thumbnail.data.inspections as string[]).includes(itemId)

          if (matchesItemType && thumbnail.data.file_category === 'image') {
            acc.push(index)
          }
          return acc
        },
        []
      )

      return {
        urls: indexes.map((index) => assetThumbnailURLs[index]),
        thumbnails: indexes.map((index) => assetThumbnails[index]),
      }
    },
    [assetThumbnails, assetThumbnailURLs]
  )

  const getItemThumbnailUrls = useCallback(
    (itemId: string) => getThumbnailUrls(itemId, subSectionType),
    [getThumbnailUrls, subSectionType]
  )

  return (
    <CantileverCard.Section topPadding>
      <SectionContainer>
        <SectionNameText>{subSectionType} Images</SectionNameText>
        {subSectionItems.length > 0 ? (
          subSectionItems.map((item) => {
            const { urls: itemUrls, thumbnails: itemThumbnails } =
              getItemThumbnailUrls(item.id)
            return (
              <ImagesSubSection
                key={item.id}
                subSectionItem={item}
                subSectionURLs={itemUrls}
                subSectionThumbnails={itemThumbnails}
              />
            )
          })
        ) : (
          <NoImagesContainer>No {subSectionType} Images</NoImagesContainer>
        )}
      </SectionContainer>
    </CantileverCard.Section>
  )
}
